import React, { createContext, useState } from "react";

export const NavbarContext = createContext();

export function NavbarProvider(props) {
  const [activeNavbarMenuItemViaContext, setNavbarActiveMenuItem] =
    useState(-1);

  const handleActiveNavbarMenuItemViaContext = (menuItem) => {
    setNavbarActiveMenuItem(menuItem);
  };

  const [labelModificationInProgressViaContext, setLabelModifcationInProgress] =
    useState(false);

  const handleLabelModificationInProgressViaContext = (boolVal) => {
    setLabelModifcationInProgress(boolVal);
  };

  const [state, setState] = useState(null);

  return (
    <NavbarContext.Provider
      value={{
        activeNavbarMenuItemViaContext,
        handleActiveNavbarMenuItemViaContext,
        labelModificationInProgressViaContext,
        handleLabelModificationInProgressViaContext,
        state,
        setState,
      }}
    >
      {props.children}
    </NavbarContext.Provider>
  );
}
